/* eslint-disable eqeqeq */
import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { AddUser } from "../../../utilities/api/user/user-service";
import { UserDataObjType } from "../../../utilities/types";

type AddUserType = {
    status: string
    message: string
}

const initialState: AddUserType = {
    status: "",
    message: ""
}

export const CreateUser = createAsyncThunk("AddUser/CreateUser", (payload: UserDataObjType) => AddUser(payload))

const AddUserSlice = createSlice({
    name: "AddUser",
    initialState,
    reducers: {
        resetAddUserSlice: () => initialState

    },
    extraReducers: (builder) => {
        builder

            .addCase(CreateUser.fulfilled, (state, action: PayloadAction<any>) => {

                if (action.payload.status == "200") {
                    state.status = action.payload.status
                    state.message = action.payload.data.message
                }
                else {
                    state.status = action.payload.response.status
                    state.message = action.payload.response.data.message
                }
            })

    }
})

export default AddUserSlice.reducer
export const { resetAddUserSlice } = AddUserSlice.actions